import React, { useContext, useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ReservationAdmin.css";
import { ReservationContext } from "../../context/ReservationContext";

function ReservationAdmin() {
  const { reservedData, isLoading, handleCancelReservations } =
    useContext(ReservationContext);
  const [selectedReservations, setSelectedReservations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("isAdminAuthenticated");
    if (!isAuthenticated) {
      navigate("/ces/reservation/admin/login");
    }
  }, [navigate]);

  // console.log(
  //   "ReservationAdmin - reservedData:",
  //   reservedData,
  //   "isLoading:",
  //   isLoading,
  // );

  // 로딩 중이거나 데이터가 없는 경우 로딩 표시
  if (isLoading || !reservedData || Object.keys(reservedData).length === 0) {
    return (
      <div className="admin-container">
        <div className="admin-card">
          <div className="admin-header">
            <h2 className="admin-title">CES 2025 예약 관리</h2>
            <p className="admin-subtitle">
              {isLoading
                ? "데이터를 불러오는 중입니다..."
                : "예약된 데이터가 없습니다."}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Filter only reserved slots and sort by date and time
  const reservedSlots = Object.values(reservedData)
    .filter((slot) => slot.isReserved)
    .sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      if (dateA - dateB !== 0) return dateA - dateB;
      return a.time.localeCompare(b.time);
    });

  const handleCheckboxChange = (docId) => {
    setSelectedReservations((prev) => {
      if (prev.includes(docId)) {
        return prev.filter((id) => id !== docId);
      } else {
        return [...prev, docId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedReservations.length === reservedSlots.length) {
      setSelectedReservations([]);
    } else {
      setSelectedReservations(reservedSlots.map((slot) => slot.docId));
    }
  };

  const handleCancelSelected = async () => {
    if (selectedReservations.length === 0) {
      alert("취소할 예약을 선택해주세요.");
      return;
    }
    if (window.confirm("선택한 예약을 취소하시겠습니까?")) {
      await handleCancelReservations(selectedReservations);
      setSelectedReservations([]);
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-card">
        <div className="admin-header">
          <h2 className="admin-title">CES 2025 예약 관리</h2>
        </div>

        {reservedSlots.length === 0 ? (
          <p className="admin-subtitle">예약된 데이터가 없습니다.</p>
        ) : (
          <div className="admin-table-container">
            <div className="admin-controls">
              <button
                className="admin-btn"
                onClick={handleCancelSelected}
                disabled={selectedReservations.length === 0}
              >
                선택한 예약 취소
              </button>
              <span className="selected-count">
                {selectedReservations.length}개 선택됨
              </span>
            </div>

            <Table striped bordered hover responsive className="admin-table">
              <thead>
                <tr>
                  <th className="table__title admin-checkbox-align">
                    <input
                      id="admin-checkbox-title"
                      type="checkbox"
                      className="admin-checkbox"
                      onChange={handleSelectAll}
                      checked={
                        selectedReservations.length === reservedSlots.length &&
                        reservedSlots.length > 0
                      }
                    />
                  </th>
                  <th className="table__title">날짜</th>
                  <th className="table__title">시간</th>
                  <th className="table__title">이름</th>
                  <th className="table__title">회사</th>
                  <th className="table__title">국가</th>
                  <th className="table__title">이메일</th>
                  <th className="table__title">전화번호</th>
                  <th className="table__title">메시지</th>
                </tr>
              </thead>
              <tbody>
                {reservedSlots.map((data, index) => (
                  <tr key={index}>
                    <td className="admin-checkbox-align">
                      <input
                        type="checkbox"
                        className="admin-checkbox"
                        checked={selectedReservations.includes(data.docId)}
                        onChange={() => handleCheckboxChange(data.docId)}
                      />
                    </td>
                    <td>{data.date}</td>
                    <td>{data.time}</td>
                    <td>{data.fullName}</td>
                    <td>{data.company}</td>
                    <td>{data.country}</td>
                    <td>{data.email}</td>
                    <td>{data.phone}</td>
                    <td>{data.message}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReservationAdmin;
